<script>
import Nav from "@/components/Nav/index.vue";
import { nextTick } from "vue";
export default {
    name: "NcoinInstruction",
    data() {
        return {
            detailIndex: null,
            tab: 'ncoin'
        };
    },
    components: {
        Nav,
    },
    computed: {
        userNbInfo() {
            return this.$store.state.userNbInfo;
        },
    },
    watch: {
        userNbInfo: function () {
            let vm = this;
            if (!vm.userNbInfo.data.user.isBind) {
                vm.$router.push("/welcome");
            }
        },
    },
    mounted() {
        nextTick(() => {
            let vm = this;
            if (vm.userNbInfo.data) {
                if (!vm.userNbInfo.data.user.isBind) {
                    vm.$router.push("/welcome");
                }
            }
        });
    },
    methods: {
        showFullInfo(index) {
            // console.log("showFullInfo");
            let vm = this;
            if (index === vm.detailIndex) {
                vm.detailIndex = null;
            } else {
                vm.detailIndex = index;
            }
        },
        sendGtm(str) {
            window.dataLayer.push({
                event: "horyuken_event",
                event_name: str,
                event_time: new Date().toLocaleString(),
            });
        },
    },
};
</script>
<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped></style>
